import Swiper from 'swiper';

function productDetailPage() {

	const productSwiper = new Swiper( '.cp-product-images-slider', {
		slidesPerView: 'auto',
	});

}
export default productDetailPage;